import service from './index';

export default {
  async getProducts (config) {
    const response = await service.get('products', config);
    return response;
  },
  async getProduct (productId) {
    const response = await service.get(`products/${productId}`);
    return response;
  },
  async saveProduct (productId, data) {
    const response = await service.put(`products/${productId}`, data);
    return response;
  },
  async getProductsCount () {
    const response = await service.get('products/count', {
      hideSpinner: true,
      hideErrorMessage: true,
    });
    return response;
  },
};
